// Small shared helpers.

export const sleep = (ms: number, signal?: AbortSignal) => new Promise<void>((resolve, reject) => {
  const t = setTimeout(resolve, ms);
  signal?.addEventListener("abort", () => { clearTimeout(t); reject(new DOMException("Aborted", "AbortError")); }, { once: true });
});

export const nowMs = () => Date.now();

/** ISO-8601 UTC without fractional seconds (SYNC.md). */
export const isoNow = (d = new Date()) => d.toISOString().replace(/\.\d{3}Z$/, "Z");

export const isAbort = (e: unknown) => e instanceof DOMException && e.name === "AbortError";

/** A tiny event hub: `on(name, fn)` returns an unsubscribe function. */
export class Hub<E extends Record<string, unknown>> {
  private map = new Map<keyof E, Set<(v: any) => void>>();
  on<K extends keyof E>(name: K, fn: (v: E[K]) => void): () => void {
    if (!this.map.has(name)) this.map.set(name, new Set());
    this.map.get(name)!.add(fn);
    return () => this.map.get(name)!.delete(fn);
  }
  emit<K extends keyof E>(name: K, v: E[K]): void {
    for (const fn of [...(this.map.get(name) ?? [])]) { try { fn(v); } catch (e) { console.error(e); } }
  }
}

export async function sha1(text: string): Promise<string> {
  const buf = await crypto.subtle.digest("SHA-1", new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf), (b) => b.toString(16).padStart(2, "0")).join("");
}

export function debounce(fn: () => void, ms: number): () => void {
  let t: ReturnType<typeof setTimeout> | undefined;
  return () => { clearTimeout(t); t = setTimeout(fn, ms); };
}
